"use client"

import {QueryClient, QueryClientProvider} from "react-query";

const queryClient = new QueryClient({
    defaultOptions:{
        queries:{
            refetchOnWindowFocus: false,
        },
    }
})

export const QueryProvider = ({children}) => {
    return (
        <>
            <QueryClientProvider client={queryClient}>
                {children}
                {/*<ReactQueryDevtools initialIsOpen={false} />*/}
            </QueryClientProvider>
        </>
    );
}